/** The two `package_type` values searched — one request each, run in parallel. */
enum SearchPackageType {
  Photo = 'photo',
  Video = 'video',
}

/** Ranking formula the shop search expects; not tuned per query. */
const SEARCH_PREMIUM_FORMULA = 'hs_alt_default';

/** `limit` query param — applied per package type, so up to 2× this in total. */
const SEARCH_RESULTS_LIMIT = 30;

/** How many past terms the idle state offers. */
const RECENT_SEARCH_LIMIT = 8;

/** Placeholders rendered while a search is in flight — roughly one screenful. */
const SEARCH_SKELETON_COUNT = 6;

/** Keystroke settle time before a live (desktop dropdown) search fires. */
const SEARCH_DEBOUNCE_MS = 300;

/** Search results change rarely — keep a submitted query cached for 5 minutes. */
const SEARCH_STALE_TIME = 5 * 60 * 1000;

const SEARCH_GC_TIME = 10 * 60 * 1000;

export {
  SearchPackageType,
  SEARCH_PREMIUM_FORMULA,
  SEARCH_RESULTS_LIMIT,
  RECENT_SEARCH_LIMIT,
  SEARCH_SKELETON_COUNT,
  SEARCH_DEBOUNCE_MS,
  SEARCH_STALE_TIME,
  SEARCH_GC_TIME,
};
